import React, { useState, memo, useEffect, useRef } from "react";
import AddToolForElements from "../../components/Tool/AddToolForElements/AddToolForElements";
import "./Draggable.scss";
const Draggable = memo(function (props) {
  let elementWrapperRef = useRef(null);
  const [elementFocused, setElementFocused] = useState(false);

  useEffect(() => { });
  const handleClick = (e) => {

    // if (elementWrapperRef && elementWrapperRef.current.contains(e.target) || elementWrapperRef.current.contains(e.currentTarget)) {
    //   setElementFocused(true);
    // } else {
    //   setElementFocused(false);
    // }

      setElementFocused(true);
    
  };
  return (
    <div
      className={props.classlist +
        (elementFocused & (props.element.data === "Row" || props.element.data === "Accordion") ? " activeContainerElement" :
          elementFocused ? " activeElement" : "")}
      ref={elementWrapperRef}
      id={props.element.id}
      style={
        (props.element.data !== "Row") &
          (props.element.data !== "Line") &
          (props.element.data !== "Accordion")
          ? { ...props.style, maxWidth: props.width }
          : { ...props.style }
      }
      onDragEnter={props.onDragEnter}
      onDragOver={props.onDragOver}
      onDrop={props.onDrop}
      onDragLeave={props.onDragLeave}
      onDragEnd={props.onDragEnd}
      onClick={(e) => {
        
        props.chooseBlock && props.chooseBlock();
        handleClick(e);
      }}
      data-element={props.element.data ? props.element.data : ""}
    >
      {props.onDrag && (
        <span
          onDragStart={props.onDrag}
          draggable="true"
          className="dragHandle"
        />
      )}
      {props.children}

      <AddToolForElements
        tool={props.tool}
        layout={props.layout}
        blockClicked={elementFocused}
        setBlockClicked={() => {
          setElementFocused(false);
        }}
        element={props.element}
        ColumnNumber={props.ColumnNumber}
        mobileView={props.mobileView}
        onAddElementorColumn={props.onAddElementorColumn}
        onAddElementorColumnInColumn={props.onAddElementorColumnInColumn}
      />
    </div>
  );
});
export default Draggable;
